// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2n1YA","assignButton":"CreateEditEquipmentSchedule_assignButton__2bb-i"};